module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (90).77645908.jpg";